import BaseModel from './BaseModel';

/** Class representing a collector status. */
class CollectorStatus extends BaseModel {}

export default CollectorStatus;
